import { type MCPServerInfo } from '../../types';

const NotebookLMServer: MCPServerInfo = {
  serverId: 'NOTEBOOKLM',
  name: 'NotebookLM',
  slug: 'notebooklm',
  description:
    'Programmatic access to Google NotebookLM — create notebooks, add sources (URL, Drive, files), query with AI, generate podcasts, videos, slide decks, and more. Requires running `nlm login` before first use.',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => ({
  command: 'uvx',
  args: ['--from', 'notebooklm-mcp-cli', 'notebooklm-mcp'],
  env: config?.profile ? { NOTEBOOKLM_MCP_PROFILE: config.profile } : {}
})`
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {
      profile: {
        type: 'string',
        description:
          'Named profile for multi-account (from nlm login --profile). Leave empty for default profile.',
        sensitive: false
      }
    }
  },
  installConfig: {
    required: [],
    properties: {
      profile: {
        type: 'string',
        description:
          'Named profile for multi-account (from nlm login --profile). Leave empty for default profile.',
        sensitive: false
      }
    }
  },
  instructions: {
    installSetupInstructions: `## Requirements

1. Python 3.10+ with [uv](https://docs.astral.sh/uv/) (recommended), pip, or pipx
2. A Google account with access to [NotebookLM](https://notebooklm.google.com)
3. Chrome (for auth: \`nlm login\` launches Chrome to extract cookies)

## Instructions

### 1. Install

\`\`\`bash
# uv (recommended)
uv tool install notebooklm-mcp-cli

# Or run without installing
uvx --from notebooklm-mcp-cli notebooklm-mcp
\`\`\`

Alternatively: \`pip install notebooklm-mcp-cli\` or \`pipx install notebooklm-mcp-cli\`

### 2. Authenticate (required before first use)

\`\`\`bash
nlm login          # Launches Chrome; log in to Google, cookies auto-extracted
nlm login --check  # Verify auth status
\`\`\`

### 3. Optional

- Multi-account: \`nlm login --profile work\` (then set \`profile\` in config)
- Diagnose issues: \`nlm doctor\`
- Upgrade: \`uv tool upgrade notebooklm-mcp-cli\``
  },
  deprecated: true
};

export default NotebookLMServer;
